
const Cta = () => {
    return (
        <div className="bg-black ">
            <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
                <h1 className='text-4xl sm:text-7xl font-bold text-white'>Have a idea in mind? Let's Bring it to <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600">life</span></h1>
            </div>
        </div>
    )
}
export default Cta;